import Component from '../lib/Component'
require('intersection-observer')

export default class ObservableComponent extends Component {
  constructor (elem, APP) {
    super(elem, APP)
    this.viewOptions = {
      rootMargin: '0px',
      threshold: 0.1
    }
    this.isRendered = false
  }

  beforeInView () {

  }

  afterInView () {
    if (this.isRendered) {
      return false
    }
  }

  init () {
    this.beforeInView()
    let observer = new window.IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !this.isRendered) {
          this.afterInView()
          this.isRendered = true
        }
      })
    }, this.viewOptions)
    observer.observe(this.elem)
  }
}
